export const USER_VERIFY_REQUEST = "VERIFY_USER/USER_VERIFY_REQUEST";
export const USER_VERIFY_SUCCESS = "VERIFY_USER/USER_VERIFY_SUCCESS";
export const USER_VERIFY_FAILURE = "VERIFY_USER/USER_VERIFY_FAILURE";


// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/VerifyUser/constants.js